/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralCode } from './ReferralCode';
import {
    ReferralCodeFromJSON,
    ReferralCodeFromJSONTyped,
    ReferralCodeToJSON,
    ReferralCodeToJSONTyped,
} from './ReferralCode';

/**
 * 
 * @export
 * @interface GetReferralCodesResponse
 */
export interface GetReferralCodesResponse {
    /**
     * 
     * @type {Array<ReferralCode>}
     * @memberof GetReferralCodesResponse
     */
    referralCodes: Array<ReferralCode>;
}

/**
 * Check if a given object implements the GetReferralCodesResponse interface.
 */
export function instanceOfGetReferralCodesResponse(value: object): value is GetReferralCodesResponse {
    if (!('referralCodes' in value) || value['referralCodes'] === undefined) return false;
    return true;
}

export function GetReferralCodesResponseFromJSON(json: any): GetReferralCodesResponse {
    return GetReferralCodesResponseFromJSONTyped(json, false);
}

export function GetReferralCodesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferralCodesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referralCodes': ((json['referralCodes'] as Array<any>).map(ReferralCodeFromJSON)),
    };
}

export function GetReferralCodesResponseToJSON(json: any): GetReferralCodesResponse {
    return GetReferralCodesResponseToJSONTyped(json, false);
}

export function GetReferralCodesResponseToJSONTyped(value?: GetReferralCodesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralCodes': ((value['referralCodes'] as Array<any>).map(ReferralCodeToJSON)),
    };
}

